import { defineMessage } from 'services/localization';

export const messages = {
    dateFieldText: defineMessage('date'),
    expiryDateFieldText: defineMessage('expiry'),
    quoteNumberFieldText: defineMessage('quote_number_1'),
    referenceFieldText: defineMessage('reference'),
    titleFieldText: defineMessage('title'),
    summaryFieldText: defineMessage('summary'),
    termsFieldText: defineMessage('terms'),
    brandingThemeFieldText: defineMessage('theme'),
    emptyQuoteNumber: defineMessage('allocated_on_approval'),
};
